module.exports = __webpack_public_path__ + "static/img/gq3.a22cb508.jpg";